import { Link } from 'react-router-dom';
import { CaretRight } from '@phosphor-icons/react';

import { cn } from '../../utils/cn';

export function SettingsRow({
  icon: Icon,
  title,
  description,
  to,
  onClick,
  value,
  badge,
  rightSlot,
  variant = 'default',
  showChevron,
  className,
}) {
  const chevronVisible = showChevron ?? Boolean(to);
  const interactive = Boolean(to || onClick);

  const inner = (
    <>
      {Icon ? (
        <span
          className={cn(
            'flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px]',
            variant === 'danger'
              ? 'bg-rose-100 text-rose-800 dark:bg-rose-950/40 dark:text-rose-300'
              : variant === 'logout'
                ? 'bg-muted text-muted-foreground'
                : 'bg-sage-100 text-sage-700 dark:bg-sage-950/40 dark:text-sage-300',
          )}
        >
          <Icon className="h-[18px] w-[18px]" aria-hidden />
        </span>
      ) : null}
      <span className="min-w-0 flex-1">
        <span
          className={cn(
            'flex flex-wrap items-center gap-2 text-sm font-semibold',
            variant === 'danger' ? 'text-rose-800 dark:text-rose-300' : 'text-foreground',
          )}
        >
          {title}
          {badge ? (
            <span className="rounded-md border border-tan-200 bg-tan-50 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide text-tan-800 dark:border-tan-800 dark:bg-tan-950/30 dark:text-tan-200">
              {badge}
            </span>
          ) : null}
        </span>
        {description ? (
          <span className="mt-0.5 block text-[11.5px] leading-snug text-muted-foreground">
            {description}
          </span>
        ) : null}
      </span>
      <span className="ml-auto flex shrink-0 items-center gap-2">
        {value ? (
          <span className="text-xs font-semibold text-muted-foreground">{value}</span>
        ) : null}
        {rightSlot}
        {chevronVisible ? (
          <CaretRight className="h-[18px] w-[18px] text-muted-foreground/40" aria-hidden />
        ) : null}
      </span>
    </>
  );

  const rowClass = cn(
    'flex w-full items-center gap-3 px-4 py-3.5 text-left transition-colors',
    interactive ? 'hover:bg-muted/60' : '',
    className,
  );

  if (to) {
    return (
      <Link to={to} className={rowClass}>
        {inner}
      </Link>
    );
  }

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={rowClass}>
        {inner}
      </button>
    );
  }

  return <div className={rowClass}>{inner}</div>;
}

export function SettingsRowDivider() {
  return <div className="border-t border-border" role="separator" />;
}
